/* eslint-disable */
export default {
  downloadSuccess: 'ログがダウンロードされました。',
  downloadFail:
    'エラーログのダウンロードに失敗しました。もう一度やり直してください。',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
